import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./css/successfull.css";
import ComponentType from "../../Enum/ComponentTypeEnum";

const Successfull = ({ componentType }) => {
  const navigate = useNavigate();
  let Header = localStorage.getItem("Header");
  const OkayClickHandle = () => {
    if (Header === "Content Management (Assessment)") {
      navigate("/DcmTimeTable")
      localStorage.setItem("Header", "Content Management");
    } else if (componentType == ComponentType.ASSESSMENT) {
      navigate("/PublishedAssessment")
    } else if (componentType == ComponentType.HOMEWORK) {
      navigate("/PublishedHomework")
    }
  }
  return (
    <div className=" successful_preview_transprant_body ">
      <div className=" p-2 successful_preview_container shadow">
        {/* <img src="/images/Ellipse 208.svg" alt="" /> */}
        <img className="activityLoader" src="/gift/tick_mark.gif" alt="" />
        <span className=" my-4 successfully_message">
          You Have successfully Published
          {
            componentType == ComponentType.ASSESSMENT && " Assessment"
          }
          {
            componentType == ComponentType.HOMEWORK && " Homework"
          }
        </span>
        <button className="successfull_okay_btn" onClick={() => { OkayClickHandle() }}>Okay</button>
      </div>
    </div>
  );
};

export default Successfull;
